import _ from 'lodash'
import { err, ok, Result } from 'neverthrow'
import {
	BaseRunContext,
	CalcRuntimeError,
	CalcType,
	ExecutableCalc,
	ExecutableCalcCalculateFunction,
	ExecutableCalcCalculateOk,
	ExecutableCalcPrecedence,
	isSuperconceptStatus,
	shouldPersist,
} from '@fusion-advantage/formlib'

// these default calculations assess a concept's activation
// to proactively clear their value if they become disabled or hidden
export const createDefaultValueCalcs = (activationCalcs: ExecutableCalc[]): ExecutableCalc[] =>
	activationCalcs.map(activationCalc => {
		const calculate: ExecutableCalcCalculateFunction = (context: BaseRunContext): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
			const rActivation = activationCalc.calculate(context)
			if (rActivation.isErr()) return err(rActivation.error)
			const activationResult = rActivation.value
			if (activationResult.calcType !== CalcType.Activation) {
				return err({
					area: 'DefaultValueCalc',
					message: `Expected activation calc for '${activationCalc.outputCid}', got '${activationResult.calcType}'`,
				})
			}
			if (shouldPersist(activationResult.returnValue)) {
				// concept is still active and can still persist
				// so we don't need to null out its values or do anything else;
				// just exit
				return ok({ calcType: CalcType.Value, returnValue: [], printed: [] })
			}
			// concept is disabled or hidden, so null out any existing values
			const existingStatus = context.getStatus(activationCalc.outputCid)
			if (isSuperconceptStatus(existingStatus)) {
				// for superconcept with subconcepts,
				// clear all subconcept values
				const returnValue = _.keys(existingStatus.subconcepts)
					.map(subconceptCid => ({ value: null, subconceptCid }))
				return ok({ calcType: CalcType.Value, returnValue, printed: [] })
			}
			// clear existing concept value
			return ok({ calcType: CalcType.Value, returnValue: [{ value: null }], printed: [] })
		}
		return new ExecutableCalc({
			calcType: CalcType.Value,
			precedence: ExecutableCalcPrecedence.Default,
			outputCid: activationCalc.outputCid,
			inputCids: activationCalc.inputCids,
			selectCalculate: () => calculate,
		})
	})
